import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import debounce from "lodash.debounce";
import { listInfractionsService } from "../services/listInfractions.service.js";

export const useInfractionsQuery = (filters) => {
  const fetchData = useFetch();
  const [infractions, setInfractions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchInfractions = async () => {
      try {
        setLoading(true);
        const response = await listInfractionsService(fetchData)({
          filters: { ...filters, page: currentPage, limit: 25 },
        });
        setInfractions(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchInfractions, 500);
    debounced();
    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, currentPage, filters]);

  return {
    infractions,
    currentPage,
    onChangePage: (page) => setCurrentPage(page),
    total,
    totalPages,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
